import { Form, FormProps } from 'antd';
import { useEffect } from 'react';

import useFormInitialSet from '@/hooks/useFormInitialSet';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';
import { useSelectPropsWithInitial } from '@/hooks/useSelectWithInitialValue';
import { ServiceOrderItem } from '@/model/ServiceOrder/ServiceOrderItem';

const useServiceOrderTechnicianItem = (formProps: FormProps, item?: ServiceOrderItem) => {
  // 0: product, 1: unidad, 2: device,
  const { initialValuesSetted } = useFormInitialSet(formProps.form, item, [], {
    withoutInitial: !item,
  });
  const productType = Form.useWatch('product_type', formProps.form);
  const { selectProps: productsSelectProps } = useSelectScrollSearch({
    resource: 'elements',
    optionLabel: item => item.name,
    optionValue: item => item.id,
    queryOptions: {
      enabled: productType !== undefined,
    },
    filters: [
      {
        value: productType,
        operator: 'eq' as const,
        field: 'type',
      },
    ],
  });
  const productsSelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: productsSelectProps,
    resource: 'elements',
    initialValue: item?.product,
    labelKey: 'name',
    valueKey: productType === 1 ? 'serial_number_box' : 'id',
    disabled: productType === undefined,
  });
  const { selectProps: serialNumbersSelectProps } = useSelectScrollSearch({
    resource: 'elements',
    optionLabel: item => item.name,
    optionValue: item => (productType === 1 ? item.serial_number_box : item.id),
    queryOptions: {
      enabled: productType !== undefined && (productType === 1 || productType === 2),
      queryKey: ['elements', { type: productType, serializable: true }],
    },
    filters: [
      {
        value: productType,
        operator: 'eq' as const,
        field: 'type',
      },
      { value: true, operator: 'eq' as const, field: 'serializable' },
    ],
  });
  const serialNumbersSelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: serialNumbersSelectProps,
    resource: 'elements',
    initialValue: productType == 1 ? item?.unidad : item?.device,
    labelKey: 'name',
    valueKey: productType === 1 ? 'serial_number_box' : 'id',
    disabled: productType === undefined,
    meta: { type: productType, serializable: true },
  });

  useEffect(() => {
    if (!item) {
      formProps.form?.resetFields(['product', 'unidad', 'device']);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productType]);

  useEffect(() => {
    if (productType != undefined && productType != 0) {
      formProps.form?.setFieldsValue({ used_amount: 1 });
    }
  }, [formProps.form, productType]);

  return {
    initialValuesSetted,
    productsSelectProps: productsSelectPropsWithInitials,
    productType,
    serialNumbersSelectProps: serialNumbersSelectPropsWithInitials,
  };
};

export default useServiceOrderTechnicianItem;
